import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SearchSecondaryFilterOptions from './SearchSecondaryFilterOptions';
import MaxWidthContainer from '../Global/Containers/MaxWidthContainer';
import HorizontalScroll from '../Global/Containers/HorizontalScroll';
import Dropdown from '../Global/Dropdowns/Dropdown';
import Button from '../Global/Buttons/Button';
import Icon from '../Global/Icons/Icon';

const SearchSecondaryFilters = ({ filters, filterDropdownOpen, onDropdownClick, onFilterChange, activeFilters, onClearClick }) => {
  const activeFiltersKeys = Object.keys(activeFilters);

  return (
    <div className="search-results-new__secondary-filters">
      <MaxWidthContainer classes="position-relative">
        <HorizontalScroll dropdownActive={filterDropdownOpen} constant>
          <ul className="inline-list-new m-b-3">
            {/* Map through all the secondary level filters */}
            {Object.keys(filters).map((key) => {
              const filter = filters[key];
              const { display_text: topLevelLabel } = filter;

              // The following block is to get the active state on the filter dropdown button if a filter within is selected
              let active = false;
              // If active filters exist
              if (activeFiltersKeys.length > 0) {
                switch (filter.expected_type) {
                  // If a string or an array then we simply check to see if the key name exists
                  case `string`:
                  case `array`:
                    if (filter.param in activeFilters) {
                      active = true;
                    }
                    break;

                  // If there is no expected_type, then we need to loop through the filter options and see if the key exists
                  // Used for Age and Video filters
                  default:
                    filter.options.forEach((f) => {
                      if (f.param in activeFilters) {
                        active = true;
                      }
                    });
                }
              }
              
              const btnClasses = classnames(`secondary-filter-dropdown-btn btn btn--tertiary border-radius-s`, {
                'secondary-filter-dropdown-btn--active': active,
              });

              return (
                <li key={topLevelLabel} className="m-b-0">
                  <Dropdown 
                    size="m" 
                    label={topLevelLabel} 
                    onClick={onDropdownClick} 
                    buttonClasses={btnClasses} 
                    noArrow
                  >
                    <div className="p-t-3 p-x-3">
                      <SearchSecondaryFilterOptions filter={filter} onChange={onFilterChange} activeFilters={activeFilters} />
                    </div>
                  </Dropdown>
                </li>
              );
            })}
          </ul>
        </HorizontalScroll>

        <Button 
          onClick={onClearClick} 
          classes="search-results-new__secondary-filter__clear-btn btn--tertiary border-radius-s"
          disabled={activeFiltersKeys.length === 0}
        >
          <span className="sr-only">Clear filters</span>
          <Icon name="remove-circle-outline" />
        </Button>
      </MaxWidthContainer>
    </div>
  );
};

SearchSecondaryFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  filterDropdownOpen: PropTypes.bool.isRequired,
  onDropdownClick: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  activeFilters: PropTypes.object.isRequired,
  onClearClick: PropTypes.func.isRequired,
};

export default SearchSecondaryFilters;


// WEBPACK FOOTER //
// ./library/app/components/Search/SearchSecondaryFilters.js